import React, { useState } from 'react';

import { IconButton, Tooltip } from '@mui/material';

import { Edit, Delete, Visibility } from '@mui/icons-material';

import { IHandbookDocument } from 'core/interfaces/handbookInterface';

import { getHandbookDocumentUrl } from 'core/API/handbookDocuments';

import { PdfViewerDialog } from 'core/components/PdfViewerDialog/PdfViewerDialog';

import styles from '../SchedulerSetting.module.scss';



interface HandbookDocumentsListProps {

  documents: IHandbookDocument[];

  onEditClick: (document: IHandbookDocument) => void;

  onDeleteClick: (document: IHandbookDocument) => void;

}



const HandbookDocumentsList: React.FC<HandbookDocumentsListProps> = ({

  documents,

  onEditClick,

  onDeleteClick,

}) => {

  const [viewingDocument, setViewingDocument] = useState<IHandbookDocument | null>(null);



  const formatDate = (dateString?: string): string => {

    if (!dateString) return '—';

    return new Date(dateString).toLocaleDateString(undefined, {

      year: 'numeric',

      month: 'short',

      day: 'numeric',

    });

  };



  const handleOpenDocument = (doc: IHandbookDocument) => {

    if (doc.filePath) {

      setViewingDocument(doc);

    }

  };



  const viewingDocumentUrl = getHandbookDocumentUrl(viewingDocument?.filePath);



  if (documents.length === 0) {

    return (

      <div className={styles.emptyState}>

        <p>No employee handbook documents uploaded yet.</p>

        <p>Click &quot;Add&quot; to add a PDF.</p>

      </div>

    );

  }



  return (

    <>

      <div className={styles.tableContainer}>

        <table className={styles.workplaceTable} style={{ tableLayout: 'fixed' }}>

          <thead>

            <tr>

              <th style={{ width: '32%' }}>Document Name</th>

              <th style={{ width: 80, textAlign: 'center' }}>Version</th>

              <th style={{ width: 130, whiteSpace: 'nowrap' }}>Last Updated</th>

              <th style={{ width: 120, minWidth: 120, textAlign: 'center' }}>Actions</th>

            </tr>

          </thead>

          <tbody>

            {documents.map((doc) => (

              <tr key={doc.id}>

                <td style={{ maxWidth: 0 }}>
                  <Tooltip
                    title={doc.name}
                    placement="top"
                    componentsProps={{ tooltip: { sx: { fontSize: '0.8rem', px: 1.5, py: 0.75 } } }}
                  >
                    <strong
                      style={{
                        display: 'block',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {doc.name}
                    </strong>
                  </Tooltip>
                </td>

                <td style={{ textAlign: 'center' }}>

                  <span>v{doc.version ?? 1}</span>

                </td>

                <td style={{ whiteSpace: 'nowrap' }}>

                  <span>{formatDate(doc.updatedAt || doc.createdAt)}</span>

                </td>

                <td style={{ textAlign: 'center', width: 120, minWidth: 120, whiteSpace: 'nowrap' }}>

                  {doc.filePath && (

                    <Tooltip title="View">

                      <IconButton

                        size="small"

                        onClick={() => handleOpenDocument(doc)}

                        aria-label={`View ${doc.name}`}

                        className={styles.iconButton}

                        sx={{ color: '#446388' }}

                      >

                        <Visibility fontSize="small" />

                      </IconButton>

                    </Tooltip>

                  )}

                  <IconButton

                    size="small"

                    title="Edit"

                    onClick={() => onEditClick(doc)}

                    className={styles.iconButton}

                  >

                    <Edit className={styles.editIcon} />

                  </IconButton>

                  <IconButton

                    size="small"

                    title="Delete"

                    onClick={() => onDeleteClick(doc)}

                    className={styles.iconButton}

                    color="error"

                  >

                    <Delete />

                  </IconButton>

                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>



      <PdfViewerDialog

        open={!!viewingDocument}

        onClose={() => setViewingDocument(null)}

        pdfUrl={viewingDocumentUrl}

        title={viewingDocument?.name}

      />

    </>

  );

};



export default HandbookDocumentsList;


